import {UnLitElement} from "../../../common/elements";
import {customElement, query} from "lit/decorators.js";
import type {EopMultiCarousel} from "../multiCarousel";
import {resolve} from "../../../container";
import {EventBus} from "../../../common/eventBus";
import {YOUTUBE_SHORT_TILE_PLAY_VIDEO_EVENT} from "../youtubeShortTile";

@customElement("eop-energy-bits-slider")
export class EnergyBitsSlider extends UnLitElement {

    @query("eop-multi-carousel")
    private multiCarousel: EopMultiCarousel;

    public constructor(private eventBus: EventBus = resolve(EventBus)) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();

        this.eventBus.on(YOUTUBE_SHORT_TILE_PLAY_VIDEO_EVENT, (_event) => {
            this.multiCarousel.querySelectorAll("eop-youtube-short-tile").forEach((tile) => {
                tile.pauseVideo();
            });
        });
    }
}